module.exports = __webpack_public_path__ + "img/version_bg.f6bcea74.png";